import styled, { css } from "styled-components"
import Breakpoints from "../shared/breakpoints"
import { FontFamilyRegular } from "../shared/typography.styles"

export const OverlayStyle = css`
  background-color: var(--tricorn-black);
`

export const StatListItem = styled.li`
  color: var(--white);
  ${FontFamilyRegular}
  font-style: normal;
  text-transform: uppercase;
  text-align: center;

  font-weight: 400;
  letter-spacing: 0.08em;

  font-size: 10px;
  line-height: 10px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (min-width: ${Breakpoints.md}) {
    margin: 24px 0;
  }

  @media (min-width: ${Breakpoints.lg}) {
    font-weight: 300;
    margin: 32px 0;
    font-size: 14px;
    line-height: 13px;
  }
`
export const StatListSmall = styled.span`
  font-size: 30px;
  margin-left: 5px;
  line-height: 0px;

  @media (min-width: ${Breakpoints.md}) {
    font-size: 16px;
    font-weight: 400;
  }
  @media (min-width: ${Breakpoints.lg}) {
    font-size: 30px;
  }
`

export const StatListNumber = styled.span`
  display: inline-flex;
  align-items: baseline;
  font-size: 24px;
  line-height: 140%;
  max-height: 48px;

  align-self: center;

  @media (min-width: ${Breakpoints.md}) {
    font-size: 30px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    font-size: 48px;
    line-height: 46px;
    margin: 0 0 8px 0;
  }
`

export const StatListContainer = styled.ul`
  width: 100%;
  grid-column: 1 / -1;
  display: flex;
  justify-content: space-around;
  padding: 32px 0;
  margin-bottom: 8px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;

    padding: 0;
    align-items: center;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 3 / -3;
    margin-bottom: 0;
  }
`

export const StatListPlus = styled.span`
  font-size: 30px;
  line-height: 29px;
  margin-left: 5px;
  align-self: center;

  @media (min-width: ${Breakpoints.md}) {
    font-size: 16px;
    font-weight: 400;
  }
  @media (min-width: ${Breakpoints.lg}) {
    font-size: 30px;
  }
`
